/**
 * @generated SignedSource<<344c0942c81e7d6345edb5b0ce2dca91>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsPullRequestStatus = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type prStatusLozenge_softwareCodePage_PRStatusLozengeFragment$data = {
  readonly status: DevOpsPullRequestStatus | null | undefined;
  readonly " $fragmentType": "prStatusLozenge_softwareCodePage_PRStatusLozengeFragment";
};
export type prStatusLozenge_softwareCodePage_PRStatusLozengeFragment$key = {
  readonly " $data"?: prStatusLozenge_softwareCodePage_PRStatusLozengeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"prStatusLozenge_softwareCodePage_PRStatusLozengeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "prStatusLozenge_softwareCodePage_PRStatusLozengeFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "eef5e8e142caa8d4cf710ffced3d46cc";

export default node;
